export const environment = {
  production: false,
  schematicsVersionUsed: '1.3.0',
  BFF_BASE_URL: '',
  TRACKING_ADOBE_URL: '',
  TRACKING_APP_NAME: ''
};
